module.exports = __webpack_public_path__ + "static/media/icon-covid-global-recovered.7bfa2b9b.svg";